export default __webpack_public_path__ + "static/media/icon-luxury.7d6e1aef.svg";